import { formatPayout } from "@/lib/numbers";

/** Format a CPI amount for display. */
export function formatCpiAmount(value) {
	if (value == null || !Number.isFinite(Number(value))) {
		return "—";
	}
	return `$${formatPayout(value)}`;
}

/**
 * Classify a CPI change for badges / colors.
 * @param {number|null|undefined} from
 * @param {number|null|undefined} to
 * @param {{ coverage?: "added"|"removed", unsupported?: boolean }|null} [change]
 */
export function getCpiChangeKind(from, to, change = null) {
	if (change?.unsupported || (change?.coverage === "added" && to == null)) {
		return "unsupported";
	}
	if (change?.coverage === "removed") {
		return "removed";
	}
	if (change?.coverage === "added") {
		return "added";
	}
	if (from == null && to == null) {
		return "unsupported";
	}
	if (from == null && to != null) {
		return "added";
	}
	if (from != null && to == null) {
		return "removed";
	}
	if (from != null && to != null && to > from) {
		return "increase";
	}
	if (from != null && to != null && to < from) {
		return "decrease";
	}
	return "changed";
}

/** Short user-facing label for a CPI change kind. */
export function getCpiChangeLabel(kind, _change = null) {
	switch (kind) {
		case "added":
			return "Added";
		case "removed":
			return "Removed";
		case "unsupported":
			return "Not supported";
		case "increase":
			return "Going up";
		case "decrease":
			return "Going down";
		default:
			return "Changed";
	}
}

/** Plain-language reason chips for the modal. */
export function formatCpiImpactReasonLabel(reason) {
	const map = {
		"OS-version targeting added": "OS version targeting added",
		"OS-version targeting removed": "OS version targeting removed",
		"City/region targeting added": "City / region targeting added",
		"City/region targeting removed": "City / region targeting removed",
		"Country / OS targeting changed": "Country or OS targeting changed",
		"Targeting changed": "Targeting changed",
		"Effective CPI changed": "Effective CPI changed",
	};
	if (map[reason]) {
		return map[reason];
	}
	// Keep "Added countries: GB, US" / "Removed countries: FR" as-is.
	return reason;
}

/**
 * Plain-text fallback (logs / non-UI). Prefer the structured confirm modal in Admin.
 * @deprecated Use RewardedMarketplaceCpiImpactConfirmModal for UI.
 */
export function formatRewardedMarketplaceCpiImpactMessage(impact) {
	const increases = Number(impact?.increases || 0);
	const decreases = Number(impact?.decreases || 0);
	const pubs = (impact?.publishers || []).length;
	const parts = [
		"Marketplace Rewarded CPI will change for connected publishers.",
		increases || decreases
			? `Summary: ${increases} up, ${decreases} down across ${pubs} publisher(s).`
			: null,
		(impact?.reasons || []).map(formatCpiImpactReasonLabel).join("; ") || null,
	].filter(Boolean);
	return parts.join(" ");
}
